import React from "react";
import { X } from "lucide-react";
import { Link } from "react-router-dom";
import FlexBtn from "../../Components/Common/FlexBtn";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const FeeSlip = (props) => {
    const { onRequestClose, selectedItem } = props;
    const { t } = useTranslation();

    const handleSubmitData = () => {
        const input = document.getElementById('fee-slip-content');
        html2canvas(input, {
            scale: 2,
            useCORS: true,
            allowTaint: true,
            logging: true,
        }).then((canvas) => {
            const imgWidth = 210;
            const pageHeight = 297;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'mm', 'a4');
            let position = 0;
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            pdf.save("fee-slip.pdf");
        });
    };

    return (
        <>
            <div  className="container-fluid p-0 m-0 pb-4 modalWrapper" style={{maxHeight: "90vh", overflowY: "auto"}}>
                <div className="row d-flex justify-content-center p-0 m-0">
                    <div className="col-md-12 examModalWrapper p-0 m-0">
                        <div className="d-flex justify-content-between align-items-center px-4 col-md-12 examModalHeader">
                            <h4 style={{ color: "#060317" }} className="fw-bold">
                                {t("FeesSlip")}
                            </h4>
                            <div className="iconWrapper cursor-pointer" onClick={onRequestClose}>
                                <X />
                            </div>
                        </div>
                    </div>
                </div>
                <div id="fee-slip-content" className="row mt-3 p-0 m-0 px-4 ">
                    <div className="col-md-12">
                        <h1 className="text-center fw-bold text-2xl">School Name</h1>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <div className="d-flex align-items-center">
                                <img src={selectedItem.picture} alt="Student" className="rounded-circle" style={{ width: "50px", height: "50px", marginRight: "15px" }} />
                                <div>
                                    <h5 className="mb-0">{selectedItem.studentName}</h5>
                                    <small className="text-muted">{selectedItem.enrollmentNo}</small>
                                </div>
                            </div>
                        </div>
                        <table className="table-auto w-full border-collapse">
                            <tbody>
                                <tr className="border">
                                    <th className="border px-2 pt-2 pb-3 text-center bg-[#241763] text-white">Description</th>
                                    <td className="border px-2 pt-2 pb-3 text-center bg-[#241763] text-white">Details</td>
                                </tr>
                                <tr className="border">
                                    <th className="border px-2 pt-2 pb-3 text-center">{t("Payment Date")}</th>
                                    <td className="border px-2 pt-2 pb-3 text-center">{new Date(selectedItem.paymentDate).toLocaleDateString()}</td>
                                </tr>
                                <tr className="border">
                                    <th className="border px-2 pt-2 pb-3 text-center">{t("Amount Paid")}</th>
                                    <td className="border px-2 pt-2 pb-3 text-center">{selectedItem.amountPaid.toFixed(2)} Rs</td>
                                </tr>
                                <tr className="border">
                                    <th className="border px-2 pt-2 pb-3 text-center">{t("Total Fee")}</th>
                                    <td className="border px-2 pt-2 pb-3 text-center">{selectedItem.feeBill.totalFee.toFixed(2)} Rs</td>
                                </tr>
                                <tr className="border">
                                    <th className="border px-2 pt-2 pb-3 text-center">{t("Discount Amount")}</th>
                                    <td className="border px-2 pt-2 pb-3 text-center">{selectedItem.feeBill.discountAmount.toFixed(2)} Rs</td>
                                </tr>
                                <tr className="border">
                                    <th className="border px-2 pt-2 pb-3 text-center">{t("Final Amount")}</th>
                                    <td className="border px-2 pt-2 pb-3 text-center">{selectedItem.feeBill.finalAmount.toFixed(2)} Rs</td>
                                </tr>
                                <tr className="border">
                                    <th className="border px-2 pt-2 pb-3 text-center">{t("Pending Amount")}</th>
                                    <td className="border px-2 pt-2 pb-3 text-center">{selectedItem.feeBill.pendingAmount.toFixed(2)} Rs</td>
                                </tr>
                                <tr className="border">
                                    <th className="border px-2 pt-2 pb-3 text-center">{t("Billing Cycle Start Date")}</th>
                                    <td className="border px-2 pt-2 pb-3 text-center">{new Date(selectedItem.feeBill.billingCycleStartDate).toLocaleDateString()}</td>
                                </tr>
                                <tr className="border">
                                    <th className="border px-2 pt-2 pb-3 text-center">{t("Billing Cycle End Date")}</th>
                                    <td className="border px-2 pt-2 pb-3 text-center">{new Date(selectedItem.feeBill.billingCycleEndDate).toLocaleDateString()}</td>
                                </tr>
                                <tr className="border">
                                    <th className="border px-2 pt-2 pb-3 text-center">{t("Due Date")}</th>
                                    <td className="border px-2 pt-2 pb-3 text-center">{new Date(selectedItem.feeBill.dueDate).toLocaleDateString()}</td>
                                </tr>
                                <tr className="border">
                                    <th className="border px-2 pt-2 pb-3 text-center">{t("Status")}</th>
                                    <td className="border px-2 pt-2 pb-3 text-center">{selectedItem.feeBill.status}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-md-12 px-4 mt-3 py-3">
                    <div className="d-flex gap-3 justify-content-end">
                        <Link onClick={onRequestClose}>
                            <FlexBtn label={t("Cancel")} color="#463C77" bgColor="#EDEBF1" />
                        </Link>
                        <Button type="primary" onClick={handleSubmitData}>
                            {t("Download")}
                        </Button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FeeSlip;
